import InfoBubbleAlt from './InfoBubbleAlt';

export default InfoBubbleAlt;
